var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgRejectedcomponent = function SvgRejectedcomponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 28 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M11 7h6v15h-6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.696 21.53 16.019 1.155c-.876-1.514-3.162-1.563-4.038 0L.304 21.531C-.572 23.045.547 25 2.347 25h23.305c1.8 0 2.92-1.906 2.044-3.47Zm-13.672-4.25c1.217 0 2.238 1.026 2.238 2.247a2.237 2.237 0 0 1-2.238 2.248c-1.265 0-2.238-.977-2.238-2.248 0-1.221.973-2.248 2.238-2.248Zm-2.14-8.063c-.05-.342.243-.635.583-.635h3.066c.34 0 .632.293.583.635l-.34 6.646c-.049.341-.292.537-.584.537h-2.384c-.292 0-.535-.195-.584-.537l-.34-6.646Z",
    fill: "current"
  })));
};
export default SvgRejectedcomponent;